// Set false to disable auto-login without removing mitra credentials below.
export const AUTO_LOGIN_ENABLED = false;

const MITRA_AUTO_LOGIN = {
    10022: {
        username: 'pclayananperpustakaandigital@gmail.com',
        password: 'Swt110719@',
    },
};

export function getMitraAutoLogin(clientId) {
    return MITRA_AUTO_LOGIN[Number(clientId)];
}

export function shouldMitraAutoLogin(clientId) {
    if (!AUTO_LOGIN_ENABLED) {
        return false;
    }
    return !!getMitraAutoLogin(clientId);
}
